<template>
    <main class="main">
      <header class="page-header">
        <h1>
          Projects
          <a href="#" title="RSS" aria-label="RSS">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" height="23">
              <path d="M4 11a9 9 0 0 1 9 9" />
              <path d="M4 4a16 16 0 0 1 16 16" />
                <circle cx="5" cy="19" r="1" />
            </svg>
          </a>
        </h1>
        <div class="post-meta">
          <span>A brief overview of my pinned GitHub repositories</span>
        </div>
      </header>
      <div class="archive-year" v-if="loaded">
        <div class="archive-month">
          <h3 class="archive-month-header">Pinned repos</h3>
          <div class="archive-posts">
            <Pinned v-for="(project, index) in projects" :data="project" v-bind:key="index" />
          </div>
        </div>
      </div>
      <div class="post-content" v-else>
        <h3 id="intro">Loading stuff</h3>
        <p>Please wait</p>
        <hr>
      </div>
      <footer class="page-footer" v-if="loaded">
        <span class="centering-cta">
          <a class="cta-link" href="https://github.com/davidlares" target="_blank" ref="noopener noreferrer edit">View complete Github Profile »</a>
        </span>
      </footer>
    </main>
  </template>
  
  <script>
  import Pinned from '@/components/Pinned'
  import axios from "axios"
  export default {
    name: 'Projects',
    data() {
      return {
        projects: {},
        loaded: false
      }
    },
    components: {
      Pinned
    },
    async mounted() {
      await this.loadProjects()
    },
    methods: {
        async loadProjects() {
            try {
                // query
                const query = `query {
                    user(login: "davidlares") {
                        pinnedItems(first: 6, types: REPOSITORY) {
                            nodes {
                                ... on Repository {
                                    name
                                    description
                                    url
                                    stargazerCount
                                    primaryLanguage {
                                        name
                                    }
                                }
                            }
                        }
                    }
                }`;
                // headers
                const headers = {
                    'Authorization': `Bearer ${process.env.VUE_APP_GITHUB_TOKEN}`,
                    'Content-Type': 'application/json'
                }
                let { data } = await axios.post(process.env.VUE_APP_GITHUB_REPOS_ENDPOINT, { query }, { headers })
                this.projects = data.data.user.pinnedItems.nodes
                this.loaded = true
            } catch (err) {
                console.log('err', err)
            }
        }
    }
  }
  </script>
  